import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { BaseRepository } from '@common/data/base';
import { PatchAlterarSenhaDto, PostAuthDto } from '@data/auth/dto';
import { PatchAlterarSenhaModel, PostAuthModel } from '@data/auth/models';
import { environment } from '@environment/environment';
import { ApiResources } from '@constants/api-resources';
import { PostRecuperarSenhaDto } from './dto/post-recuperar-senha.dto';
import { PostRecuperarSenhaModel } from './models/post-recuperar-senha.model';
import { PatchMultiClientAcessDto } from './dto/patch-multi-client-acess.dto';

@Injectable()
export class AuthRepository extends BaseRepository {
  constructor(http: HttpClient) {
    super(http, environment.serverAuthUrl, ApiResources.ACCESS_TOKEN);
  }

  postAccessToken(body: PostAuthDto): Observable<PostAuthModel> {
    return this.customClient.post(ApiResources.ACCESS_TOKEN, body).pipe<any>(
      map((item) => {
        if (item.data) {
          return item.data;
        }
        this.handleResponseRequest(item);
      }),
    );
  }

  postRefreshToken(token: string): Observable<string> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'X-API-Key': token,
    });
    return this.customClient.get(ApiResources.REFRESH_TOKEN, headers).pipe<any>(
      map((item) => {
        if (item.token) {
          return item.token;
        }
        throw Error(item.toString());
      }),
    );
  }

  postRecuperarSenha(
    body: PostRecuperarSenhaDto,
  ): Observable<PostRecuperarSenhaModel> {
    return this.customClient.post(ApiResources.RECUPERAR_SENHA, body).pipe<any>(
      map((item) => {
        if (item.data) {
          return item.data;
        }
        this.handleResponseRequest(item);
      }),
    );
  }

  patchAlterarSenha(
    body: PatchAlterarSenhaDto,
  ): Observable<PatchAlterarSenhaModel> {
    return this.customClient.patch(ApiResources.ALTERAR_SENHA, body).pipe<any>(
      map((item) => {
        if (item.data) {
          return item.data;
        }
        this.handleResponseRequest(item);
      }),
    );
  }

  patchMultiClientAccess(body: PatchMultiClientAcessDto): Observable<PostAuthModel> {
    return this.customClient.patch(ApiResources.MULTI_CLIENT_ACESS, body).pipe<any>(
      map((item) => {
        if (item.data) {
          return item.data;
        }
        this.handleResponseRequest(item);
      }),
    );
  }

  getLogout(): Observable<PatchAlterarSenhaModel> {
    return this.customClient.get(ApiResources.LOGOUT);
  }
}
